import { setTerms } from './helpers';

export const setAmenity = setTerms('amenity');
